import { Navigate } from 'react-router-dom';

import { authorized, authorizedLoader, isOrganizationUser } from '../../../utils/loaders.ts';
import {
    contactTabLoader,
    filesTabLoader,
    jobEditLoader,
    jobTabLoader,
    profileTabLoader,
    userEditLoader,
    userTabLoader,
} from './loaders.ts';
import {
    ADMIN_ORGANIZATION_SETTINGS_CONTACT_PATH,
    ADMIN_ORGANIZATION_SETTINGS_FILES_PATH,
    ADMIN_ORGANIZATION_SETTINGS_JOBS_ADD_PATH,
    ADMIN_ORGANIZATION_SETTINGS_JOBS_EDIT_PATH,
    ADMIN_ORGANIZATION_SETTINGS_JOBS_PATH,
    ADMIN_ORGANIZATION_SETTINGS_PATH,
    ADMIN_ORGANIZATION_SETTINGS_PROFILE_PATH,
    ADMIN_ORGANIZATION_SETTINGS_USERS_ADD_PATH,
    ADMIN_ORGANIZATION_SETTINGS_USERS_EDIT_PATH,
    ADMIN_ORGANIZATION_SETTINGS_USERS_PATH,
} from './paths.ts';

export default [
    {
        handle: {
            title: ['admin:organizationSettingsPage.documentTitle'],
        },
        path: ADMIN_ORGANIZATION_SETTINGS_PATH,
        lazy: async () => ({ Component: (await import('./pages/OrganizationSettingsPage.tsx')).default }),
        loader: authorized(isOrganizationUser),
        children: [
            {
                index: true,
                element: <Navigate to={ADMIN_ORGANIZATION_SETTINGS_PROFILE_PATH} replace={true} />,
            },
            {
                handle: {
                    title: ['admin:organizationSettingsPage.profileTabDocumentTitle'],
                },
                path: ADMIN_ORGANIZATION_SETTINGS_PROFILE_PATH,
                lazy: async () => ({ Component: (await import('./tabs/ProfileTab.tsx')).default }),
                loader: authorizedLoader(profileTabLoader, isOrganizationUser),
            },
            {
                handle: {
                    title: ['admin:organizationSettingsPage.contactTabDocumentTitle'],
                },
                path: ADMIN_ORGANIZATION_SETTINGS_CONTACT_PATH,
                lazy: async () => ({ Component: (await import('./tabs/ContactTab.tsx')).default }),
                loader: authorizedLoader(contactTabLoader, isOrganizationUser),
            },
            {
                handle: {
                    title: ['admin:organizationSettingsPage.filesTabDocumentTitle'],
                },
                path: ADMIN_ORGANIZATION_SETTINGS_FILES_PATH,
                lazy: async () => ({ Component: (await import('./tabs/FilesTab.tsx')).default }),
                loader: authorizedLoader(filesTabLoader, isOrganizationUser),
            },
            {
                handle: {
                    title: ['admin:organizationSettingsPage.jobsTabDocumentTitle'],
                },
                path: ADMIN_ORGANIZATION_SETTINGS_JOBS_PATH,
                lazy: async () => ({ Component: (await import('./tabs/JobsTab.tsx')).default }),
                loader: authorizedLoader(jobTabLoader, isOrganizationUser),
                children: [
                    {
                        handle: {
                            title: ['admin:organizationSettingsPage.addJobDocumentTitle'],
                        },
                        path: ADMIN_ORGANIZATION_SETTINGS_JOBS_ADD_PATH,
                        lazy: async () => ({ Component: (await import('./tabs/JobsTab.tsx')).AddJobFormDialog }),
                    },
                    {
                        handle: {
                            title: ['admin:organizationSettingsPage.editJobDocumentTitle'],
                        },
                        path: ADMIN_ORGANIZATION_SETTINGS_JOBS_EDIT_PATH,
                        lazy: async () => ({ Component: (await import('./tabs/JobsTab.tsx')).EditJobFormDialog }),
                        loader: authorizedLoader(jobEditLoader, isOrganizationUser),
                    },
                ],
            },
            {
                handle: {
                    title: ['admin:organizationSettingsPage.usersTabDocumentTitle'],
                },
                path: ADMIN_ORGANIZATION_SETTINGS_USERS_PATH,
                lazy: async () => ({ Component: (await import('./tabs/UsersTab.tsx')).default }),
                loader: authorizedLoader(userTabLoader, isOrganizationUser),
                children: [
                    {
                        handle: {
                            title: ['admin:organizationSettingsPage.addUserDocumentTitle'],
                        },
                        path: ADMIN_ORGANIZATION_SETTINGS_USERS_ADD_PATH,
                        lazy: async () => ({ Component: (await import('./tabs/UsersTab.tsx')).AddUserFormDialog }),
                    },
                    {
                        handle: {
                            title: ['admin:organizationSettingsPage.editUserDocumentTitle'],
                        },
                        path: ADMIN_ORGANIZATION_SETTINGS_USERS_EDIT_PATH,
                        lazy: async () => ({ Component: (await import('./tabs/UsersTab.tsx')).EditUserFormDialog }),
                        loader: authorizedLoader(userEditLoader, isOrganizationUser),
                    },
                ],
            },
        ],
    },
];
